<app-dialog [config]="config" (actionButtonClicked)="dialogRef.close()">
    <ng-container dialog-title>
        Search Client
    </ng-container>

    <ng-container dialog-process-in-progress>
        <div class="row" *ngIf="searchClientForm && searchClientForm.form" [formGroup]="searchClientForm.form">
            <div class="col">
                <app-select
                    [formControlName]="searchClientForm.controls.clientType.name"
                    [control]="searchClientForm.controls.clientType"
                ></app-select>
            </div>
            <div class="col">
                <app-panel-input
                    [formControlName]="searchClientForm.controls.clientName.name"
                    [control]="searchClientForm.controls.clientName"
                ></app-panel-input>
            </div>
            <div class="col">
                <app-panel-input
                    [formControlName]="searchClientForm.controls.clientEmail.name"
                    [control]="searchClientForm.controls.clientEmail"
                ></app-panel-input>
            </div>
        </div>
        <app-report-table
            [config]="dataTableConfig"
            (rowClicked)="onFormSubmit($event)"
        ></app-report-table>
    </ng-container>
</app-dialog>
